import React from 'react'
import { GifExpertApp } from '../giphyScreenComponents/GifExpertApp'

export const GiphyScreen = () => {
  return (
      <GifExpertApp />
     
  )
}
